import { Component, OnInit, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { NavController, ModalController, NavParams, LoadingController, Events } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';
import { ValidationService } from '../../../../../UI/src/app/shared/validation/validation.service';
import { AuthRequestDTO, OTPRequestDTO } from '../../../../../UI/src/app/shared/authentication/otp-request-dto';
import { SigninComponent } from './components/signin/signin.component';
import { ProfileService } from '../../../../../UI/src/app/shared/profile/profile.service';
import { JobService } from '../../../../../UI/src/app/shared/job/job.service';
import { ResumeService } from '../../../../../UI/src/app/shared/resume/resume.service';
import { CandidateProfileComponent } from '../candidate-profile/candidate-profile.component';
import { AddResumeComponent } from './components/add-resume/add-resume.component';
import { JobDetailsPage } from '../job-search/components/job-details/job-details.component';
import { ToastControllerService } from '../../../providers/toast-controller.service';
import { TranslateService } from '@ngx-translate/core';
import { Toast508Service } from '../../../providers/toast-508.service';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { SettingsService } from '../../../../../UI/src/app/shared/settings/settings.service';
import { Storage } from '../../../../../UI/src/app/shared/constants';
import * as moment from 'moment/moment';
import * as _ from 'lodash';
import { CandidatePreferenceDTO } from '../edit-profile/profile/profile.component';

@Component({
  selector: 'page-authentication',
  templateUrl: './authentication.component.html'
})
export class AuthenticationComponent implements OnInit {
  @Output() callBack = new EventEmitter<any>();
  public userIdentifier = '';
  public isEmail = false;
  public firstName = "";
  public lastName = "";
  public userEmailId = "";
  public userMobileNumber = "";
  public dateFormat: any;
  public password = "";
  public confirmPassword = "";
  public showLoader = false;
  public userCountry: any = "";
  public userCountries: any;
  public userState: any = "";
  public userStates: any;
  public userCity = "";
  public userZipCode = "";
  public oneTimePassword = "";
  public acceptTermsAndConditions = false;
  public requestDTO: OTPRequestDTO;
  public wizardStep = 1;
  public wizardStepData: any;
  public wizardLinkedInStep = 0;
  public disableSubmit: boolean = true;
  public alertData: any;
  public action: string = '';
  public candidateProfileComponent: any = CandidateProfileComponent;
  public addResumeComponent: any = AddResumeComponent;
  public jobDetailsPage: any = JobDetailsPage;
  private accessCode: string;
  public loading;
  public authTranslations: any;
  private toastErr: any;
  private authRequest: AuthRequestDTO;
  public emailValue;
  public captchaSiteKey = '0';
  public isJobApply = false;
  user: any = {};
  fields: any;
  public userCreationForm: FormGroup;
  passwordMatch = false;
  personJsonString: string;
  public isBothEnabled: boolean;
  private careerSiteSettings: any;
  public resumeSkip = false;
  private alive = true;
  isLoggedin= this.authenticationService.isUserLoggedin();
  public isApplyWithLinkedIn: boolean;
  public isResumeRequired: boolean;
  public isResumeExists: boolean;
  public resumeDetails: any;
  public todayDate: string;
  candidateAttachments = [];
  preferences: CandidatePreferenceDTO;
  hasZipField = false;
  postalCodesLookup=[];
  public countryFieldKey = 'PersonCommunication_1.Country';
  public stateFieldKey = 'PersonCommunication_1.StateName';
  public zipFieldKey = 'PersonCommunication_1.Zip';
  zipcodeInputId='';
  
constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private validationService: ValidationService,
    public modalCtrl: ModalController,
    private profileService: ProfileService,
    private jobService: JobService,
    public loadingCtrl: LoadingController,
    private toastService: ToastControllerService,
    private translate: TranslateService,
    public events: Events,
    private toast508Service: Toast508Service,
    private settingsService: SettingsService,
    private resumeService: ResumeService,
    private cdRef: ChangeDetectorRef,
   
  ) {
    this.loading = this.loadingCtrl.create({
      duration: 15000
    });

    this.preferences = new CandidatePreferenceDTO();
    var culture = window.localStorage.getItem(Storage.CULTURE);
    this.dateFormat = moment.localeData(culture).longDateFormat('L');
    this.todayDate = new Date().toISOString();
    this.getCaptchaKey();
    this.getCountries();
   
  
    this.isEmail = navParams.get("isEmail") != undefined ? navParams.get("isEmail") : false;
    this.careerSiteSettings = authenticationService.getLoginSettings();
    if (this.careerSiteSettings){
      this.setDefaultLogin(this.careerSiteSettings);
    } else {
      this.settingsService.GetLoginSettings().subscribe(
        settings => {
          this.setDefaultLogin(settings);
          this.switchInputFormat(this.isEmail);
        });
    }
      this.translate.get(['CAREER_USER_EMAIL_EXISTS', 'CAREER_SENT_CONFIRMATION_CODE', 'CAREER_FAILED_MESSAGE',
      'CAREER_CREATE_PROFILE_FAILED', 'CAREER_INVALID_OTP', 'CAREER_PERSONAL_INFO', 'CAREER_PROF_INFO', 'CAREER_REVIEW_CONFIRM',
      'CAREER_EMAIL_VALIDATION', 'CAREER_MOBILE_VALIDATION', 'CAREER_OPTION_SELECT_STATES', 'CAREER_OPTION_SELECT_COUNTRY', 'CAREER_USER_EXISTS', 'CAREER_USER_MOBILE_EXISTS', 'CAREER_FILL_MANDATORY_FILEDS','CAREER_RESUME_LINKEDIN_UPLOAD_FAIL' ])
      .subscribe((obj) => {
        this.authTranslations = obj;
        if (this.authenticationService.isAppliedwithLinkedIn) {
          this.isResumeRequired = this.authenticationService.isResumeRequired;
          this.isApplyWithLinkedIn = this.authenticationService.isAppliedwithLinkedIn;
          this.resumeDetails = this.resumeService.linkedInResume;
          if (this.isLoggedin) {
            this.resumeService.getResumeImportedFrom().subscribe(resumeType => {
              if (resumeType !== 0 && resumeType !== null) {
                this.isResumeExists = true;
              }
            });
          }
          if (this.isResumeRequired) {
            if (this.isLoggedin){
          this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
            { stepNum: 3, stepName: this.authTranslations.CAREER_PROF_INFO },
            { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
          } else {
            this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
              { stepNum: 2, stepName: this.authTranslations.CAREER_EMAIL_VALIDATION },
              { stepNum: 3, stepName: this.authTranslations.CAREER_PROF_INFO },
              { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
            }
          }
          else {
            if(this.isLoggedin){
              this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
                { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
            }
            else {
              this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
                { stepNum: 2, stepName: this.authTranslations.CAREER_EMAIL_VALIDATION },
                { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
            }
          }
        } else if (!this.isEmail) {
          this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
            { stepNum: 2, stepName: this.authTranslations.CAREER_MOBILE_VALIDATION },
            { stepNum: 3, stepName: this.authTranslations.CAREER_PROF_INFO },
            { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
        } else {
          this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
            { stepNum: 2, stepName: this.authTranslations.CAREER_EMAIL_VALIDATION },
            { stepNum: 3, stepName: this.authTranslations.CAREER_PROF_INFO },
            { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
        }
      });

    this.requestDTO = new OTPRequestDTO();
    this.authRequest = new AuthRequestDTO();
    this.action = navParams.get("action");
    this.isJobApply = navParams.get("isJobApply") ? true : false;

    if(this.isEmail) {
      this.userEmailId = navParams.get("userIdentifier");
      this.requestDTO.UserIdentifier = this.userEmailId;
    }
    else {
      this.userMobileNumber = navParams.get("userIdentifier");
      this.requestDTO.UserIdentifier = this.userMobileNumber;
    }
    this.accessCode = location.href.split('?code=')[1];
    if (this.accessCode) {
      this.wizardStep = 3;
    }
    if(this.action === 'REVIEW_RESUME') {
      this.wizardStep = 4;
    }

  }

  switchInputFormat(input) {
    this.authenticationService.isEmail = input;
    this.authenticationService.isLoginTypeChanged = true;
    if(input) {
      this.userEmailId = this.userEmailId;
      this.isEmail = input;
      this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
        { stepNum: 2, stepName: this.authTranslations.CAREER_EMAIL_VALIDATION },
        { stepNum: 3, stepName: this.authTranslations.CAREER_PROF_INFO },
        { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
        // Remove Mobile number form validator
      if ( this.userCreationForm !== undefined && this.userCreationForm.controls['user.PersonCommunication_1.Mobile']) {
        this.userCreationForm.controls['user.PersonCommunication_1.Mobile'].setErrors(null);
      }
    }
    else {
      this.userMobileNumber = this.userMobileNumber;
      this.isEmail = input;
      this.wizardStepData = [{ stepNum: 1, stepName: this.authTranslations.CAREER_PERSONAL_INFO },
        { stepNum: 2, stepName: this.authTranslations.CAREER_MOBILE_VALIDATION },
        { stepNum: 3, stepName: this.authTranslations.CAREER_PROF_INFO },
        { stepNum: 4, stepName: this.authTranslations.CAREER_REVIEW_CONFIRM }];
      // Set Form validators back when mobile is selected.
      if (this.userCreationForm.controls['user.PersonCommunication_1.Mobile'] && this.user['PersonCommunication_1.Mobile']) {
        this.userCreationForm.controls['user.PersonCommunication_1.Mobile'].setErrors(null);
      } else {
        this.userCreationForm.controls['user.PersonCommunication_1.Mobile'].setErrors({ 'invalid': true });
      }
    }
  }

  nextStep() {
    if (this.wizardStep === 1) {
      this.generateOTP();
    } else if (this.wizardStep === 2) {
      // OTP Confirmation
      this.validateOTP();
    }
  }

  saveLinkedInData() {
    this.loading.present();
    const jsonRequest = this.authenticationService.constructUserObject(this.user);
    this.profileService.saveCandidateProfile(jsonRequest, this.candidateAttachments, this.preferences).subscribe(
      (response) => {
        if (response.responseStatus) {
          if (this.isResumeRequired) {
            this.loading.dismiss();
            this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: false,
            isJobApply: true, navigatedFrom: "linkedin"});
            this.navCtrl.push(AuthenticationComponent, { "action": "upload"});
          } else {
          this.parseLinkedInData();
        }
        } else if (response.response.error_code === '-2') {
          this.loading.dismiss();
          this.alertData = {
            message: response.response.error_message, type: 'error'
          };
        } else if (response.response.error_code === '-1' || response.response.error_code === '0') {
          this.loading.dismiss();
          this.alertData = {
            message: response.response.error_message, type: 'error'
          };
        }
      }, (error) => {
        this.loading.dismiss();
        this.alertData = {
          message: this.authTranslations.CAREER_FAILED_MESSAGE, type: 'error'
        };
      }
    );
  }

  parseLinkedInData() {
    this.resumeService.setReviewAndConfirm(true);
    this.resumeService.setAddResumeFromScratch(false);
    this.resumeService.setFromGetMatched(false);
    this.resumeService.setFromEditResume(false);
    this.resumeService.parseLinkedInResumeData(this.resumeDetails).then(
      (response) => {
        if (response) {
          this.resumeService.saveResumeData(response)
          .takeWhile(() => this.alive)
          .subscribe(obj => {
            this.loading.dismiss();
            this.resumeService.setResume(obj);
            this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: false,
            isJobApply: true, navigatedFrom: "linkedin"});
            this.navCtrl.push(AuthenticationComponent,{"action" : "REVIEW_RESUME"});
      }, err => {
        this.loading.dismiss();
        console.log('error in saving obj', err);
      });
        } else {
          this.loading.dismiss();
          this.translate.get(['CAREER_RESUME_LINKEDIN_UPLOAD_FAIL'])
            .subscribe((translationsObj) => {
              this.alertData = { message: this.translate['CAREER_RESUME_LINKEDIN_UPLOAD_FAIL'], type: 'warning' };
            });
        }
      }, (error) => {
        this.loading.dismiss();
        this.alertData = { message: this.translate['CAREER_RESUME_LINKEDIN_UPLOAD_FAIL'], type: 'warning' };
      });
  }

  setLinkedInProfile()  {
    const profileData = this.resumeDetails;
    this.user['Person.FirstName'] = this.user['Person.FirstName'];
    this.user['Person.LastName'] = this.user['Person.LastName'];
    this.user['PersonCommunication_1.Mobile'] = this.user['PersonCommunication_1.Mobile'];
    this.user['PersonCommunication_1.Email1'] = this.isLoggedin ?
    this.user['PersonCommunication_1.Email1'] : profileData.emailAddress;
    this.loading.dismiss();
  }
  setDefaultLogin(careerSiteSettings: any) {
    this.authenticationService.setLoginType(careerSiteSettings);
    this.isEmail = this.authenticationService.getRegistrationType();
    this.isBothEnabled = this.authenticationService.getLoginType();
  }
  cancelStep() {
    if (this.wizardStep === 1) {
      this.navCtrl.pop();
    } else {
      this.wizardStep = 1;
      this.disableSubmit = true;
      this.alertData = null;
    }
  }

  termsAndContions() {
    this.navCtrl.push(TermsConditionsComponent);
  }

  signin() {
    const previousState = this.navCtrl.getPrevious();
    if (previousState && previousState.name === "SigninComponent") {
      this.navCtrl.pop();
    } else {
      this.navCtrl.push(SigninComponent, {"isJobApply": this.isJobApply, "navigatedFrom": 'LOGIN_PAGE'});
    }
  }

  generateOTP(resend?: boolean) {
    if (this.userCreationForm.valid || this.acceptTermsAndConditions) {
      this.loading.present();
      this.personJsonString = this.authenticationService.constructUserObject(this.user);
      this.fillRequestDto();
      this.authenticationService.generateOTP(this.requestDTO).subscribe(
        (response) => {
          this.loading.dismiss();
          if (!response.responseStatus) {
            this.alertData = {
              message: response.response.error_message, type: 'error'
            }
            if (!this.isEmail) {
              this.getPhoneNumber(this.requestDTO.UserIdentifier);
            }
            this.toastService.presentToast(this.alertData);
            this.toast508Service.toFocus();
            return;
          }
          if (resend && response.responseStatus) {
            this.alertData = { message: this.authTranslations.CAREER_SENT_CONFIRMATION_CODE, type: 'success' };
            this.toastService.presentToast(this.alertData);
            this.toast508Service.toFocus();
            return;
          }
          this.wizardStep++;
          this.wizardLinkedInStep++;
          this.alertData = null;
        }, (error) => {
          this.loading.dismiss();
          this.alertData = { message: this.authTranslations.CAREER_FAILED_MESSAGE, type: 'error' };
          this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
        }
      );
    } else {
      this.alertData = { message: this.authTranslations.CAREER_FILL_MANDATORY_FILEDS, type: 'error' };
      this.toastService.presentToast(this.alertData);
      this.toast508Service.toFocus();
    }
  }

  private validateOTP() {
    this.loading.present();
    this.authenticationService.setIdentifier(this.requestDTO.UserIdentifier);
    this.personJsonString = this.authenticationService.constructUserObject(this.user);
    this.constructAuthRequest();
    this.authenticationService.validate(this.authRequest).subscribe(
      (response) => {
        window.localStorage.setItem(Storage.AUTH_TOKEN, JSON.parse(response));
        if (this.toastErr) {
          this.toastErr.dismiss();
        }
        this.profileService.getProfileData().subscribe(profileData => {
          if (profileData[0].resumeType === 0) {
            if((this.isApplyWithLinkedIn && !this.isResumeRequired)){
              this.parseLinkedInData();
            }
            else
            {
              if(this.isApplyWithLinkedIn)
              {
                this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: false,
                isJobApply: this.isApplyWithLinkedIn , navigatedFrom: "linkedin"});
              }
              else
              {
                this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: true, isJobApply: this.isJobApply});
              }
              this.navCtrl.push(AuthenticationComponent, { "action": "upload"});
              this.wizardStep++;
            }
          } else {
            this.events.publish('showSiteMapNodes', true);
             this.navCtrl.setRoot(CandidateProfileComponent);
            }
          });
          this.alertData = null;
        }, (error) => {
          if (this.toastErr) {
            this.toastErr.dismiss();
          }
          this.loading.dismiss();
          this.alertData = { message: this.authTranslations.CAREER_INVALID_OTP, type: 'error' };
          this.toastErr = this.toastService.presentToast(this.alertData);
          this.toast508Service.toFocus();
        });
    }

  public reviewProfile(data) {
    this.wizardStep++;
    this.resumeService.setResumeAction({action: 'REVIEW_RESUME', isInititalCreation: true, isJobApply: this.isJobApply});
  }

  setPhoneNumber(data) {
    this.userIdentifier = data;
  }

  ngOnInit() {
    if (this.action === 'request') {
      if (this.isLoggedin) {
        this.navCtrl.setRoot(CandidateProfileComponent);
      }
      this.wizardStep = 1;
      this.getCandidateCreationForm();
      this.getCaptchaKey();
    } else if (this.action === 'validate') {
      if (this.isLoggedin) {
        this.navCtrl.setRoot(CandidateProfileComponent);
      }
      this.wizardStep = 2;
      this.wizardLinkedInStep = 2;
      this.resumeSkip=true;
    } else if (this.action === 'upload') {
      this.wizardStep = 3;
      this.wizardLinkedInStep = this.isLoggedin ? 2 : 3;
    } else if (this.action === 'REVIEW_RESUME') {
      this.wizardStep = 4;
      this.wizardLinkedInStep = this.isResumeRequired ? (this.isLoggedin ? 3 : 4) :
      (this.isLoggedin ? 2 : 3);
    } else if(this.action === 'linkedin' && this.isApplyWithLinkedIn) {
      this.loading.present();
      if (this.isLoggedin) {
        this.getCandidateCreationFormWithData();
        } else {
          this.getCandidateCreationForm();
        }
        this.wizardStep=1;
        this.wizardLinkedInStep =1;
        this.getCaptchaKey();
    } else {
      if (this.isLoggedin) {
        this.navCtrl.setRoot(CandidateProfileComponent);
      } else {
        this.navCtrl.push(SigninComponent, {"isJobApply": this.isJobApply, "navigatedFrom": 'LOGIN_PAGE'});
      }
    }
    this.requestDTO.UserIdentifier = this.authenticationService.getIdentifier();
    this.isEmail = this.authenticationService.getRegistrationType();
  }

  fillRequestDto() {
    this.requestDTO = {
      UserIdentifier: this.isEmail ? this.user['PersonCommunication_1.Email1'] : this.user['PersonCommunication_1.Mobile'],
      IsEmail: this.isEmail ? true : false,
      Password: this.user['UserLogin.UserPassword'],
      FirstName: this.user['Person.FirstName'],
      LastName: this.user['Person.LastName'],
      JsonString: this.personJsonString
    }
  }

  private constructAuthRequest() {
    this.authRequest = {
      Username: this.requestDTO.UserIdentifier,
      Password: this.requestDTO.Password,
      OTP: this.oneTimePassword,
      JsonString: this.personJsonString,
      IsAppliedWithLinkedin: this.isApplyWithLinkedIn
    };
  }

  getCaptchaKey() {
    this.settingsService.getCaptchaKey().subscribe(
      key => {
        this.captchaSiteKey = key.toString();
      }
    );
  }

  searchStates() {
    this.user[this.countryFieldKey] = this.userCountry.countryCd;
    this.getStatesByCountry();
  }

  getCountries() {
    this.loading.present();
    this.authenticationService.getCountries().subscribe(
      (response) => {
        this.loading.dismiss();
        this.userCountries = response || [];
        this.getStatesByCountry();
      }, (error) => {
        this.loading.dismiss();
      }
    );
  }

  getStatesByCountry() {
    this.userStates = [];
      if (this.userCountry != undefined) {
      if (this.userCountry.hasProvince) {
        this.loading.present();
        this.authenticationService.getStatesByCountry(this.userCountry.countryCd).subscribe(
          (response) => {
            this.loading.dismiss();
            this.userStates = response || [];
            
            
          }, (error) => {
            this.loading.dismiss();
          });
        }
        else {
          this.userStates = [];
          if (this.hasZipField) {
            this.authenticationService.getPostalCodesByCountryState(this.userCountry.countryCd, '').subscribe((response) => {
              this.postalCodesLookup = _.uniq((response || []).map(r => _.capitalize(r.postalCd)));
            });
          }
        }
      }
    }

    validateMobileNumber(mobileField) {
      if (mobileField === undefined || mobileField === '') {
        return false;
      }
      return this.isEmail ? true : (mobileField ? true : false);
    }

    validateEmailAddress() {
      return this.isEmail ? ValidationService.isValidEmail(this.userEmailId) : true;
    }

    isValidForm() {
      //return this.createUser.valid && this.validateMobileNumber() && this.validateEmailAddress() && this.termsAndConditions;
    }

    getPhoneNumber(inputPhoneNumber) {
      if (typeof (inputPhoneNumber) !== 'boolean') {
        this.user['PersonCommunication_1.Mobile'] = inputPhoneNumber;
        if (!this.isEmail) {
          if (this.userCreationForm.controls['user.PersonCommunication_1.Mobile'] && inputPhoneNumber) {
            this.userCreationForm.controls['user.PersonCommunication_1.Mobile'].setErrors(null);
          } else {
            this.userCreationForm.controls['user.PersonCommunication_1.Mobile'].setErrors({ 'invalid': true });
          }
        }
      }
    }

    private getCandidateCreationForm() {
      this.loading.present();
      this.authenticationService.getCandidateConfigurationForm().subscribe(
        (response) => {
          let formObject = {
            fields: [],
            user: {}
          };
          formObject = this.authenticationService.constructFieldAttributes(response.fields, this.user);
          this.fields = formObject.fields;
          this.user = formObject.user;
          this.constructUserCreationForm();
          this.hasZipField = _.findIndex(response.fields, (item) => { return item.fieldName === this.zipFieldKey }) !== -1
        }, (error) => {
          this.loading.dismiss();
        }
      );
    }

    private getCandidateCreationFormWithData() {
      this.showLoader = true;
      this.profileService.getCandidateCreateFormConfiguration().subscribe(
        (response) => {
          let formObject = {
            fields: [],
            user: {}
          };
          formObject = this.authenticationService.constructFieldAttributes(response.fields, this.user);
          this.fields = formObject.fields;
          this.user = formObject.user;
          this.setLinkedInProfile();
          this.constructUserCreationForm();
        }, (error) => {
          this.showLoader = false;
        }
      );
    }

    private constructUserCreationForm() {
      let validatorObject = {};
      validatorObject = this.authenticationService.constructUserForm(this.fields,this.isApplyWithLinkedIn ? 'editAccount' : 'createAccount');
      this.userCreationForm = this.formBuilder.group(validatorObject);
      if (this.captchaSiteKey !== '0') {
        this.userCreationForm.addControl('captcha', new FormControl('', Validators.required));
      }
      this.userCreationForm.addControl('user.PersonCommunication_1.Mobile',
      new FormControl('user.PersonCommunication_1.Mobile', Validators.required));
      if (!this.isEmail && !this.user['PersonCommunication_1.Mobile']) {
        this.userCreationForm.controls['user.PersonCommunication_1.Mobile'].setErrors({ 'invalid': true });
      } else if ((!this.isEmail && this.user['PersonCommunication_1.Mobile']) || this.isEmail) {
        this.userCreationForm.controls['user.PersonCommunication_1.Mobile'].setErrors(null);
      }
      this.loading.dismiss();
      this.cdRef.detectChanges();
    }

    checkPasswordMatch() {
      if (this.user['UserLogin.UserPassword'] !== undefined
      && this.user['UserLogin.UserPassword'] !== '' && this.user['UserLogin.ConfirmUserPassword'] !== ''
      && this.user['UserLogin.ConfirmUserPassword'] !== undefined) {
        if (this.user['UserLogin.ConfirmUserPassword'] === this.user['UserLogin.UserPassword']) {
          this.passwordMatch = false;
          return false;
        } else if (this.user['UserLogin.ConfirmUserPassword'] !== this.user['UserLogin.UserPassword']) {
          this.passwordMatch = true;
          return true;
        }
      }
    }
   

     loadPostalCodes(){
      this.zipcodeInputId='zipcode';
     
   
       if (this.hasZipField && this.user[this.stateFieldKey]) {
         this.authenticationService.getPostalCodesByCountryState(this.user[this.countryFieldKey], this.user[this.stateFieldKey])
           .subscribe((response) => {
             this.postalCodesLookup = _.uniq((response || []).map(r => _.capitalize(r.postalCd)));
           });
       }
     }
     selectedZipcode(zipcode: any) {
       this.user['PersonCommunication_1.Zip'] = zipcode;
     }
   
     onfocusout(event: any) {
 
     }

}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/authentication.component.ts